import React, { useCallback } from 'react'
import { Box, useMediaQuery } from '@mui/material'
import PropTypes from 'prop-types'

import Search from '@hapana/shared/web/components/shared/search/search.component'

import {
  CLIENT_SIDE_SEARCH_DEBOUNCE_VALUE,
  FILTER_MODES,
  SERVER_SIDE_SEARCH_DEBOUNCE_VALUE,
} from '../../../table.constants'
import { styles } from '../../../table.styles'
import { tableGlobalFilterStyles } from './table-global-filter.styles'

const TableGlobalFilter = ({
  placeholder,
  onFilter,
  hasFilters,
  initialValue,
  setPage,
  isDisabled,
  searchSlot,
  hasToolbarWithBorder,
  searchEndAdornment,
  showSearchFieldBorder,
  searchIconPosition,
  filterMode,
}) => {
  const debounceValue =
    filterMode === FILTER_MODES.SERVER_SIDE
      ? SERVER_SIDE_SEARCH_DEBOUNCE_VALUE
      : CLIENT_SIDE_SEARCH_DEBOUNCE_VALUE
  const isMobileOrTablet = useMediaQuery((theme) => theme.breakpoints.down('md'))

  const onChange = useCallback((value) => {
    onFilter(value || '')
    setPage?.(0)
    // TODO: For some reason, after the refactor of the table, the onFilter
    // dependency is not being correctly memoized by the table library hook,
    // so doing this to avoid infinite re-renders, since changes on the
    // onFilters prop are not expected to happen.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const calculatedPosition = searchIconPosition || (isMobileOrTablet ? 'end' : 'start')

  return (
    <Box
      sx={[
        styles.search.root,
        !hasFilters && styles.search.onlySearch,
        isMobileOrTablet && { display: 'flex', gap: 0 },
      ]}
    >
      <Search
        placeholder={placeholder}
        searchCallback={onChange}
        debounceValue={debounceValue}
        initialValue={initialValue || ''}
        isDisabled={isDisabled}
        searchIconPosition={calculatedPosition}
        hasToolbarWithBorder={hasToolbarWithBorder}
        showSearchFieldBorder={showSearchFieldBorder}
        inputPropsSx={
          isMobileOrTablet && searchSlot ? tableGlobalFilterStyles.mobileInputProps : {}
        }
        endAdornment={searchEndAdornment}
      />
      {isMobileOrTablet && searchSlot && (
        <Box sx={tableGlobalFilterStyles.searchSlotContainer}>{searchSlot}</Box>
      )}
    </Box>
  )
}

TableGlobalFilter.propTypes = {
  onFilter: PropTypes.func,
  placeholder: PropTypes.string,
  hasFilters: PropTypes.bool,
  initialValue: PropTypes.string,
  setPage: PropTypes.func,
  isDisabled: PropTypes.bool,
  showSearchFieldBorder: PropTypes.bool,
  searchSlot: PropTypes.node,
  searchEndAdornment: PropTypes.node,
  searchIconPosition: PropTypes.oneOf(['start', 'end']),
  filterMode: PropTypes.oneOf(Object.values(FILTER_MODES)),
}

TableGlobalFilter.defaultProps = {
  showSearchFieldBorder: true,
}

export default TableGlobalFilter
